export default __webpack_public_path__ + "static/media/crossroads17.87e435f5.webp";